import {policyLinks} from './policyLinks';
import {NavLink,useParams} from 'react-router-dom';
import {useLangTranslation} from '../utils/translation';
export default function PolicyNav(){const {lang='en'}=useParams();const t=useLangTranslation('common');return <nav className="policy-nav" aria-label={t('footer.policyLabel')}>{policyLinks.map(([path,key])=><NavLink key={path} to={`/${lang}/${path}`}>{t(`footer.policies.${key}`)}</NavLink>)}</nav>;}
